var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.41,
    y: 315.74,
    width: 26.48,
    height: 11.19,
    transform: "translate(861.29 642.67) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.18,
    y: 329.85,
    width: 26.48,
    height: 11.19,
    transform: "translate(890.84 670.89) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.42,
    y: 192.16,
    width: 26.48,
    height: 11.19,
    transform: "translate(439.31 395.52) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.19,
    y: 206.27,
    width: 26.48,
    height: 11.19,
    transform: "translate(468.86 423.74) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.9,
    y: 192.16,
    width: 26.48,
    height: 11.19,
    transform: "translate(498.28 395.52) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.34,
    y: 329.85,
    width: 26.48,
    height: 11.19,
    transform: "translate(109.16 670.88) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.11,
    y: 46.74,
    width: 26.48,
    height: 11.19,
    transform: "translate(138.71 104.66) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.34,
    y: 60.85,
    width: 26.48,
    height: 11.19,
    transform: "translate(109.16 132.88) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.41,
    y: 46.74,
    width: 26.48,
    height: 11.19,
    transform: "translate(861.29 104.66) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.84,
    y: 71.26,
    width: 142.8,
    height: 159.32,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.25,
    y: 80.67,
    width: 123.99,
    height: 140.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.46,
    y: 105.53,
    width: 43.7,
    height: 51.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.88,109.05a1.57,1.57,0,1,1-1.57-1.57A1.57,1.57,0,0,1,351.88,109.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,115.9c4.42-.34,8.84-.36,13.25-.41s8.84.07,13.26.41c-4.42.34-8.84.36-13.26.41S341.2,116.24,336.78,115.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,120a63.51,63.51,0,0,1,14.41,0,54.38,54.38,0,0,1-7.21.41A56.07,56.07,0,0,1,336.78,120Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,124.09a91.54,91.54,0,0,1,9.21-.41,88.49,88.49,0,0,1,9.2.41c-3.07.32-6.13.39-9.2.41S339.85,124.41,336.78,124.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,128.18c3.84-.32,7.68-.4,11.52-.41s7.68.09,11.52.41c-3.84.32-7.68.4-11.52.41S340.62,128.5,336.78,128.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,132.27c3.33-.32,6.67-.39,10-.41s6.67.09,10,.41c-3.34.32-6.68.4-10,.41S340.11,132.59,336.78,132.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,136.36c4.27-.34,8.54-.36,12.81-.41s8.54.07,12.81.41c-4.27.35-8.54.37-12.81.42S341.05,136.7,336.78,136.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,140.46a73.87,73.87,0,0,1,8.27-.41,71.74,71.74,0,0,1,8.28.41,83.71,83.71,0,0,1-16.55,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,144.55c4.42-.34,8.84-.36,13.25-.41s8.84.07,13.26.41c-4.42.34-8.84.36-13.26.41S341.2,144.89,336.78,144.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,148.64c4.42-.34,8.84-.36,13.25-.41s8.84.07,13.26.41c-4.42.34-8.84.37-13.26.41S341.2,149,336.78,148.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.82,
    y: 137.82,
    width: 51.71,
    height: 61.28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.13,142.28a1.57,1.57,0,1,1-1.57-1.57A1.57,1.57,0,0,1,385.13,142.28Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,153.11a37,37,0,0,1,5.74-.42,35.65,35.65,0,0,1,5.73.42,40.32,40.32,0,0,1-11.47,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,157.73a61.69,61.69,0,0,1,7.43-.42,59.54,59.54,0,0,1,7.42.42,67.44,67.44,0,0,1-14.85,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,162.35a51.32,51.32,0,0,1,6.88-.41,49.54,49.54,0,0,1,6.88.41,57.93,57.93,0,0,1-13.76,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,167a51.32,51.32,0,0,1,6.88-.41,49.54,49.54,0,0,1,6.88.41,57.93,57.93,0,0,1-13.76,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,171.59a38.87,38.87,0,0,1,6-.41,37.65,37.65,0,0,1,6,.41,43.82,43.82,0,0,1-12,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,176.21a63.26,63.26,0,0,1,7.65-.41,61.28,61.28,0,0,1,7.65.41,71.57,71.57,0,0,1-15.3,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,180.83a48.84,48.84,0,0,1,12.63,0,48.84,48.84,0,0,1-12.63,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,185.45a76.6,76.6,0,0,1,15.83,0,76.6,76.6,0,0,1-15.83,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,190.07a76.6,76.6,0,0,1,15.83,0,76.6,76.6,0,0,1-15.83,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,153.11a63.18,63.18,0,0,1,7.52-.42,61,61,0,0,1,7.51.42,69.08,69.08,0,0,1-15,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,157.73a27.54,27.54,0,0,1,4.94-.42,26.51,26.51,0,0,1,4.94.42,30,30,0,0,1-9.88,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,162.35a54.18,54.18,0,0,1,7.07-.41,52.39,52.39,0,0,1,7.07.41,61.16,61.16,0,0,1-14.14,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,167a51.32,51.32,0,0,1,6.88-.41,49.63,49.63,0,0,1,6.88.41,57.93,57.93,0,0,1-13.76,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,171.59a61.14,61.14,0,0,1,7.52-.41,59.07,59.07,0,0,1,7.51.41,69.08,69.08,0,0,1-15,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,176.21a38.78,38.78,0,0,1,6-.41,37.45,37.45,0,0,1,6,.41,43.74,43.74,0,0,1-12,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,180.83a61.16,61.16,0,0,1,14.14,0,61.16,61.16,0,0,1-14.14,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,185.45a36.69,36.69,0,0,1,10.94,0,36.69,36.69,0,0,1-10.94,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,190.07a33.75,33.75,0,0,1,10.49,0,33.75,33.75,0,0,1-10.49,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.14,
    y: 91.29,
    width: 26.3,
    height: 26.3,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.86,94a1.57,1.57,0,1,1-1.57-1.57A1.57,1.57,0,0,1,382.86,94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.58,
    y: 80.67,
    width: 3.55,
    height: 140.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.49,
    cy: 94.19,
    r: 43.18,
    transform: "translate(-25.76 138.32) rotate(-54.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.47,
    cy: 95.15,
    r: 41.2,
    transform: "translate(-26.74 136.82) rotate(-53.13)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.46,
    cy: 95.15,
    r: 38.6,
    transform: "translate(-32.3 89.24) rotate(-35.45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.19,87c-17.58,10.65-46.47,28.12-62.61,37.7A38.64,38.64,0,0,1,88,110.47L141.43,61A38.62,38.62,0,0,1,161.19,87Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,96.5A38.37,38.37,0,0,1,159.49,109l-48.15,22.77a39.48,39.48,0,0,1-6.08-2.61C119.81,120.79,146.38,105.5,162,96.5Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.09,
    y: 59.35,
    width: 0.75,
    height: 5.85,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.66,
    y: 63.75,
    width: 0.75,
    height: 5.85,
    transform: "translate(-19 62.44) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.62,
    y: 75.79,
    width: 0.75,
    height: 5.85,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -20.67, 121.62)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 94.78,
    width: 5.85,
    height: 0.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.07,
    y: 111.21,
    width: 5.85,
    height: 0.75,
    transform: "translate(-43.08 62.48) rotate(-30.01)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 123.24,
    width: 5.85,
    height: 0.75,
    transform: "translate(-53.53 154.57) rotate(-60.02)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.09,
    y: 125.1,
    width: 0.75,
    height: 5.85,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.53,
    y: 120.69,
    width: 0.75,
    height: 5.85,
    transform: "translate(-43.07 86.51) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.56,
    y: 108.66,
    width: 0.75,
    height: 5.85,
    transform: "translate(-20.68 187.35) rotate(-59.99)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.41,
    y: 94.78,
    width: 5.85,
    height: 0.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.01,
    y: 78.34,
    width: 5.85,
    height: 0.75,
    transform: "translate(-19 86.57) rotate(-30.02)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.98,
    y: 66.31,
    width: 5.85,
    height: 0.75,
    transform: "translate(12.25 154.56) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.03 62 125.3 97.75 121.63 97.71 123.03 61.99 124.03 62",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.3 82.68 122.24 98.03 120.49 94.82 145.82 81.81 146.3 82.68",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.71,95.15a1.25,1.25,0,1,1-1.25-1.25A1.24,1.24,0,0,1,124.71,95.15Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "465.97 433 411.98 433.25 357.99 433.33 250 433.5 142.01 433.34 88.02 433.25 34.02 433 88.02 432.76 142.01 432.67 250 432.5 357.99 432.67 411.98 432.76 465.97 433",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.46,141.23a73.77,73.77,0,0,1,.35-9.17,75.45,75.45,0,0,1,1.35-9.07,73.85,73.85,0,0,1-.35,9.17A75.45,75.45,0,0,1,417.46,141.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06,142.28a74.81,74.81,0,0,1-4.27-8.12,73,73,0,0,1-3.37-8.53,83.55,83.55,0,0,1,7.64,16.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.92,145.89a75.64,75.64,0,0,1-7.76-4.89,72.91,72.91,0,0,1-7.19-5.71,84.33,84.33,0,0,1,14.95,10.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,151.08a83.73,83.73,0,0,1-18.24-1.7,73.61,73.61,0,0,1,9.16.35A75.61,75.61,0,0,1,406.13,151.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.52,157.75a84.73,84.73,0,0,1,15,10.6,72.35,72.35,0,0,1-7.76-4.89A75.33,75.33,0,0,1,425.52,157.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.31,152.56a83.9,83.9,0,0,1,18.25,1.7,73.7,73.7,0,0,1-9.17-.35A75.61,75.61,0,0,1,427.31,152.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.26,147.16a74.81,74.81,0,0,1,8.12-4.27,73,73,0,0,1,8.53-3.37,75.68,75.68,0,0,1-8.11,4.28A73.83,73.83,0,0,1,426.26,147.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.65,143a74,74,0,0,1,4.9-7.76,71.36,71.36,0,0,1,5.7-7.19,84.33,84.33,0,0,1-10.6,15Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195,368.79c-1.11,1.41-94.48,5.6-98.92,4.32a3,3,0,0,1-.62-.26c-5.5-2.58-29.1-20.4-32.86-27.91-3-6,14.79-38.84,21-44.47,4.13-3.73,11.79-5.2,11.79-5.2s21.62-62.4,34.95-75.46c3.35-3.28,61.25-4.56,71.59.16,4.43,2,15.2,13,15.5,15v0C217.68,237.86,196.09,367.36,195,368.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.64,368.79c-1.11,1.41-94.47,5.6-98.92,4.32a3.48,3.48,0,0,1-.62-.26c9-24.19,51-137.69,52.2-138.42s56.52-.4,69.77.56C218.35,237.86,196.76,367.36,195.64,368.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.35,224.41c-.93-.88-1.55-13.56.17-16.09,1.92-2.83,24.12-1.43,25.43,1s1.94,15.09,1.27,15.55-4.37.89-4.87.08-.47-11.29-.86-11.85-15.94-1.56-16.48-.76.77,11.4.15,11.86S162.26,225.27,161.35,224.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.43,
    y: 280.01,
    width: 7.57,
    height: 8.71,
    transform: "translate(131.1 -19.9) rotate(25.11)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.29,
    y: 285.28,
    width: 12.34,
    height: 9.94,
    transform: "translate(133.34 -18.17) rotate(25.11)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.41,312.12,94.1,353.32,67.54,340.86l19.3-41.19c3.83-8.15,11.9-12,20-8.22S117.23,304,113.41,312.12Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.41,312.12,94.1,353.32,67.54,340.86l19.3-41.19c3.83-8.15,11.9-12,20-8.22S117.23,304,113.41,312.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,293.86a1.14,1.14,0,1,1-2.07-1,1.14,1.14,0,0,1,2.07,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.85,309.35a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,112.85,309.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.61,304.88a1.14,1.14,0,0,1-1.52.54,1.14,1.14,0,1,1,1-2.06A1.15,1.15,0,0,1,100.61,304.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,315.25a1.13,1.13,0,0,1-1.52.55,1.14,1.14,0,1,1,1.52-.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.46,320.57a1.13,1.13,0,0,1-1.52.55,1.14,1.14,0,1,1,1-2.06A1.12,1.12,0,0,1,81.46,320.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.74,310.89a1.14,1.14,0,0,1-2.07-1,1.14,1.14,0,1,1,2.07,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.57,301.26a1.14,1.14,0,0,1-2.07-1,1.14,1.14,0,1,1,2.07,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.85,297.4a1.14,1.14,0,1,1-.55-1.51A1.14,1.14,0,0,1,96.85,297.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.08,308.15a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,93.08,308.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.44,301.73a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,108.44,301.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,312.37a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,105,312.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.12,318a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,89.12,318Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.44,331.44a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,96.44,331.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.63,339.15a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,92.63,339.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.82,326.69a1.14,1.14,0,0,1-1.52.55,1.14,1.14,0,1,1,1.52-.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.09,336.46a1.14,1.14,0,0,1-2.07-1,1.14,1.14,0,1,1,2.07,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.36,324.54a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,93.36,324.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.55,333a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,89.55,333Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.62,341.39a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,85.62,341.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.07,347.74a1.15,1.15,0,0,1-1.52.55,1.14,1.14,0,0,1,1-2.07A1.15,1.15,0,0,1,89.07,347.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.66,328.51a1.14,1.14,0,0,1-2.07-1,1.14,1.14,0,1,1,2.07,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.09,334.66a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,82.09,334.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.81,346.17a1.14,1.14,0,1,1-.55-1.52A1.15,1.15,0,0,1,95.81,346.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.51,342.89a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,78.51,342.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7,329.74a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,103.7,329.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9,337.86a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,99.9,337.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.63,323.06a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,100.63,323.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.65,320.53a1.14,1.14,0,1,1-.55-1.52A1.14,1.14,0,0,1,108.65,320.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.43,341.45c2.24,11,26.68,22.86,28.35,22.81s17.89-40.2,17.89-40.2S90.9,317.56,82,306C82,306,63.73,338,64.43,341.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.09,432.6H158.5c-5.76-22-11.05-41.41-14.42-53.67-2.12-7.71-3.48-12.6-3.74-13.52a1.66,1.66,0,0,0-.05-.16h98.37l3,13.79c1.19,5.58,2.7,12.62,4.44,20.67.14.7.3,1.41.45,2.15C248.53,411.08,250.76,421.53,253.09,432.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,432.6h-1.78Q163.8,405.85,156.89,379l-.38-1.51c-.09-.41.52-.6.64-.19.17.57.34,1.13.5,1.7C162.87,396.82,167.89,414.7,172.84,432.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,365.41a94.13,94.13,0,0,1-3.36,13.79c-1.1,3.58-2.43,7.45-3.93,11.44-.32.91-.68,1.79-1,2.69-4.77,12.15-11,24.53-17.44,30.41h-.05a16,16,0,0,1-2.46,1.93l-5.48,3.39a.18.18,0,0,1,0,.08h0c0,.33-.25,1.52-.56,3.44H104.39c-2.36-21.38,2.56-41.38,6.85-53.92a111.79,111.79,0,0,1,5.36-13.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,418.53a176.88,176.88,0,0,1-17.9,8.56c-1.63.7-3.26,1.39-4.92,2.06h0c-.1,0-.2.09-.3.12q-2.14.89-4.29,1.71c-1.4.54-2.79,1.1-4.21,1.62h-3.12c2.15-1.08,4.4-2,6.59-3q4.56-2,9.15-4c1.39-.6,2.78-1.21,4.16-1.83h.05c4.77-2.12,9.52-4.24,14.43-6C220.13,417.53,220.45,418.27,220,418.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.23,429.22c0,.72-.06,1.91-.2,3.38h-1c.32-1.38.61-2.51.89-3.33a.47.47,0,0,1,0-.09c.05-.13.23-.14.27,0h0S197.23,429.19,197.23,429.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.53,371.16c-1.25,2.5-2.38,5-3.43,7.62a102.7,102.7,0,0,0-7,49.46c.17,1.46.38,2.91.6,4.36H114.1A102.64,102.64,0,0,1,113,419.85a97.21,97.21,0,0,1,8.06-41.09c1.18-2.69,2.49-5.33,3.92-7.9A.31.31,0,0,1,125.53,371.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.91,403.48c.09-3.56.34-7.11.52-10.66.41-8.38.74-16.81,1.52-25.16a.26.26,0,0,1,.52,0c.1,6.48-.15,13-.28,19.47-.07,3.24-.16,6.49-.25,9.73a92.86,92.86,0,0,0-.06,9.29c.17,2.34.68,6.88,3.73,7.16,2.88.27,5.15-2.83,5.87-5.1,1.82-5.78,2.47-12,3.06-18,.35-3.55.76-18,.57-21.62,0-.23.34-.22.36,0,.2,3.66.7,7.3.82,11s.13,7.32-.1,11c-.23,3.5-.52,7-1.05,10.49a37.82,37.82,0,0,1-2.25,9.27c-1.06,2.46-2.88,4.72-5.64,5.26a7.33,7.33,0,0,1-1,.1c0,.75-.14,1.51-.19,2.25-.08,1.18-.23,2.34-.39,3.51a26.32,26.32,0,0,1-.71,3.4,12.75,12.75,0,0,1-1.2,3.24.18.18,0,0,1-.33-.09,15.69,15.69,0,0,1,.28-3.35c.16-1.14.32-2.3.55-3.42s.44-2.23.67-3.34c.15-.74.25-1.51.39-2.26a5.47,5.47,0,0,1-4.07-3.21C194.94,409.67,194.84,406.44,194.91,403.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.21,242.7c11.93,14.95,58.71,68,84.71,72.95C295.43,319,351.68,290.37,364,280c5-4.24-23.13-46.21-30-44.52-7.44,1.83-47.92,28.74-53.18,28.43S234.13,240.31,209,230C193.9,223.76,186.49,234.29,193.21,242.7Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.55,290c10.82-4.17,43.63-27.18,49.08-33.16s19.89-24.29,15.73-28.93-8.8.39-8.8.39,5.47-9.45.27-13c-4.15-2.83-11.08,3.9-11.08,3.9s5.45-10.67-.16-13.52c-5.11-2.6-10.74,6.54-10.74,6.54s3.65-9.39-1.75-10.94c-6.5-1.88-12.83,14.37-19.34,20.52-1.48,1.39-45.15,22.82-45.15,22.82Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.61,211.75c-6,11.69-8.8,16.35-19,23.83-.2.14,0,.47.2.34,10.62-6.42,14.36-11.71,19.36-24C383.44,211.35,382.89,211.21,382.61,211.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.63,219.2c-5.95,12-10.5,16.51-20.57,25.12-.15.12,0,.38.2.27,10.59-7.63,16.43-12.54,20.8-25.29C394.26,218.73,393.9,218.66,393.63,219.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.06,228.73c-6.6,11.18-11.21,16.68-22.07,23.78a.24.24,0,0,0,.24.42c11.77-6.17,17.59-13,22.15-24C404.69,228.22,404.47,228,404.06,228.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.63,261.74c-28.71,8.38-57,16.77-84.5,25.15-16.47-37-18.9-74-30.18-111,28.75-8.39,57-16.77,84.61-25.16C434,187.72,436.38,224.73,447.63,261.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.63,261.74q-21.47,6.38-42.54,12.74t-41.83,12.71l-.28.09-.14-.3c-16.54-37-19-74-30.37-111-.05-.16-.09-.32-.14-.48l.47-.14c28.75-8.34,57-16.68,84.61-25l.33-.1.15.34c8.2,18.55,12.87,37.1,16.9,55.65S442.09,243.25,447.63,261.74Zm0,0c-5.71-18.51-9.21-37-13.35-55.54s-8.82-36.93-17-55.39l.47.24c-27.57,8.43-55.86,16.87-84.61,25.3l.33-.62c11.23,37,13.6,74.05,30,111.07l-.41-.21q20.64-6.22,41.79-12.44T447.63,261.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.54,192q24.33-7,48.37-14c.28.95.56,1.9.83,2.85q-24.09,7-48.51,14C347,193.94,346.77,193,346.54,192Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.26,199.24q24.45-7,48.68-14l.75,2.85q-24.26,7-48.78,14C348.7,201.14,348.48,200.19,348.26,199.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.88,206.44q24.54-7,48.91-14c.23,1,.47,1.9.69,2.85q-24.39,7-49,14C350.3,208.34,350.09,207.39,349.88,206.44Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.44,213.63q36-10.24,71.78-20.49l.69,2.86c-23.84,6.82-47.85,13.65-71.86,20.48C351.84,215.53,351.64,214.58,351.44,213.63Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,220.83q36-10.25,71.95-20.49c.22.95.44,1.9.65,2.85q-35.91,10.25-72,20.49C353.37,222.73,353.17,221.78,353,220.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.51,228l72-20.48c.21,1,.42,1.9.62,2.85-24,6.83-48,13.65-72,20.48C354.92,229.92,354.72,229,354.51,228Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.1,235.22q35.89-10.25,72-20.49c.21,1,.41,1.9.61,2.85q-36,10.24-71.94,20.49C356.53,237.12,356.31,236.17,356.1,235.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.77,242.41c23.83-6.83,47.83-13.65,71.84-20.48.21.95.41,1.9.61,2.85q-36,10.25-71.75,20.48C358.23,244.31,358,243.36,357.77,242.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.57,249.61q35.55-10.25,71.59-20.49c.21.95.41,1.9.62,2.85q-35.94,10.25-71.45,20.49C360.07,251.51,359.82,250.56,359.57,249.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.53,256.8q35.28-10.23,71.23-20.48c.22,1,.43,1.9.66,2.85-23.88,6.83-47.62,13.66-71.06,20.49C362.08,258.7,361.8,257.75,361.53,256.8Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.68,264q35-10.24,70.77-20.49c.23,1,.46,1.9.7,2.85q-35.64,10.25-70.55,20.49C364.29,265.9,364,265,363.68,264Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.07,271.2q34.62-10.24,70.2-20.49c.25.95.5,1.9.76,2.85q-35.4,10.24-69.94,20.49Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.17,192.9c-1.07-7.77-2.38-15.54-4.13-23.31,5.47,5.57,10.7,11.14,15.79,16.71l-1.5,1.37c-3.56-3.92-7.19-7.84-10.93-11.76,1.09,5.55,2,11.09,2.75,16.64Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.74,188.86l-1.16-1.59q5.34-4,10.58-8l1.2,1.59Q407.11,184.88,401.74,188.86Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.62,166.54a21.06,21.06,0,0,0-4.33,4.31,18.83,18.83,0,0,0-3.6,11.45,14.19,14.19,0,0,0,1.28,5.77A12.84,12.84,0,0,0,400.8,195c3.82.75,7.91-.62,11.33-2.88a17.39,17.39,0,0,0,7.5-9.2,13.23,13.23,0,0,0-1.46-11.41,13.85,13.85,0,0,0-4.53-4,14.43,14.43,0,0,0-5.82-1.87,12.83,12.83,0,0,0-6,.83,17.78,17.78,0,0,0-5.15,3.25,21.46,21.46,0,0,1,2.26-2.11A16.08,16.08,0,0,1,401.6,166a13.2,13.2,0,0,1,6.21-1.32,15.81,15.81,0,0,1,11.64,6,13.67,13.67,0,0,1,2.51,6.22,15.35,15.35,0,0,1-.51,6.63,19.27,19.27,0,0,1-8.29,10.32,21.77,21.77,0,0,1-6.12,2.79,14.48,14.48,0,0,1-6.7.29,13.23,13.23,0,0,1-5.88-2.9,15,15,0,0,1-3.92-5.18,17.46,17.46,0,0,1,.07-12.82A18.65,18.65,0,0,1,398.62,166.54Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.59,174q-1.72-2.36-3.51-4.71l1.57-1.16q1.8,2.35,3.54,4.71Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,173.51l-1.19-1.64,4.5-3.24c.41.55.81,1.1,1.22,1.64Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.61,244.63s10.63-10.89,15.41-16.3,16.2-22.58,22.4-22.17c7,.46,1.94,18.55-6.53,28.27,0,0,11.25,17.94,3.56,27.67-1.67,2.1-13.79,8.76-16.8,8.14Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.38,235.73c4.63,6.82,7.85,17.21,4.53,24.74a.19.19,0,0,0,.33.18c4.65-7.59,1-19.65-3.46-25.5C347.91,234,346.18,234,347.38,235.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.61,244.63,348.55,290a14.12,14.12,0,0,1-8.77,13.53c-9.53,4.17-48.95,18.39-64.56,13.12S215.08,273,195.87,247.49s9.18-20.44,14.59-18,68.92,32.37,71.18,32.32,17-11.26,24-14.74S316.61,244.63,316.61,244.63Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,316.3c-9,1.65-17.33,2.19-22.76.35-15.62-5.28-60.15-43.64-79.36-69.17-1.22-1.61-2.24-3.11-3.1-4.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.11,299.37c-2.93-3.59-5.37-7.58-7.92-11.42s-5-7.58-7.47-11.4c-5-7.69-10.17-15.33-14.64-23.31a.17.17,0,0,1,.28-.18c5.77,7.27,10.8,15.13,15.86,22.86q3.81,5.81,7.45,11.72a120.12,120.12,0,0,1,6.75,11.59C336.51,299.42,336.23,299.52,336.11,299.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325.87,308.77,322.26,310a27,27,0,0,1-.27-4c0-2.53.2-5,.17-7.41a35.89,35.89,0,0,0-.7-7.18,24.86,24.86,0,0,0-2.41-6.64c-.27-.52-.58-1-.87-1.5s-.62-.92-.95-1.38c-.71-.91-1.45-1.85-2.22-2.77l-4.6-5.59c-1.56-1.88-3.1-3.77-4.62-5.7s-3-3.93-4.37-6a43.16,43.16,0,0,1-3.67-6.76,24.18,24.18,0,0,1-.9-2.64c1.29-.85,2.56-1.67,3.76-2.43a30.08,30.08,0,0,0,1.37,3.16,60.41,60.41,0,0,0,3.65,5.86c2.68,3.9,5.5,7.83,8.33,11.8,1.41,2,2.86,4,4.18,6.07.66,1.05,1.32,2.11,1.91,3.26.29.58.58,1.15.84,1.79s.45,1.22.63,1.84c1.48,4.92,1.7,9.88,2.27,14.73A58.64,58.64,0,0,0,325.87,308.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313.25,312.68c-1,.28-1.94.55-2.93.81-1.2-4.14-1.27-8.22-1.36-12.25l0-6.24c0-1,0-2.05-.08-3.06a19.13,19.13,0,0,0-.29-2.92,3.35,3.35,0,0,0-.17-.64l-.25-.68-.3-.66c-.11-.22-.24-.43-.35-.65a13.25,13.25,0,0,0-1.8-2.39,22.28,22.28,0,0,0-4.85-3.73c-.89-.54-1.81-1-2.74-1.49l-2.81-1.43a17.55,17.55,0,0,1-5.35-3.86,9.53,9.53,0,0,1-1-1.45c-.15-.26-.28-.54-.41-.81l-.31-.8a19.94,19.94,0,0,1-.81-3.24,32.53,32.53,0,0,1-.38-6.44c0-.63.06-1.26.11-1.89l2-1.32c0,1.07,0,2.13.09,3.19a41.9,41.9,0,0,0,.68,6,20.57,20.57,0,0,0,.78,2.8l.26.66c.1.19.17.39.28.59a9.2,9.2,0,0,0,.71,1.13,21.66,21.66,0,0,0,4.24,4.06c1.63,1.25,3.4,2.38,5.15,3.53a41.55,41.55,0,0,1,5.15,3.7,16.85,16.85,0,0,1,2.27,2.35,15.11,15.11,0,0,1,.95,1.37l.41.73a6.65,6.65,0,0,1,.35.83,17.09,17.09,0,0,1,.73,3.24c.17,1.06.26,2.12.35,3.17.17,2.1.27,4.18.41,6.24s.29,4.12.49,6.14A40.35,40.35,0,0,0,313.25,312.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M106.46,385.26c.1.13,136.57-6.25,137.46-7.09.41-.39,2.18-8.16.09-18.95-6.27-32.35-25.06-98.43-41.63-126.39-4.14-7-22.8-17.29-36.34-4.07-27.45,26.8-49,95-57.49,132.46C104.39,379.53,105.9,384.48,106.46,385.26Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.4,356.13c-.41,0-.82,0-1.22.06A97,97,0,0,0,230.64,358c-7.85,1.6-15.84,3.4-23.89,5.19-4,.89-8.06,1.83-12.21,2.51-2.08.33-4.17.66-6.34.82-1.1.07-2.18.15-3.36.13s-2.18-.11-3.27-.24c-8.65-.93-16.52-3.86-24.47-6.17s-16.15-3.89-23.45-3.86c-1.8,0-3.74.15-5.69.33s-3.9.47-5.87.76c-3.93.63-7.9,1.42-11.86,2.28l-1.43.32c.48-2.1,1-4.3,1.57-6.57a98.83,98.83,0,0,1,10.46-2.83q3.12-.68,6.34-1.08c1.08-.13,2.16-.24,3.25-.3a25.63,25.63,0,0,1,3.4,0,37,37,0,0,1,12.78,3.22c3.94,1.64,7.62,3.58,11.42,5.15a60.09,60.09,0,0,0,11.66,3.64,42.22,42.22,0,0,0,11.95.63c1-.07,2-.22,2.91-.35s1.83-.37,2.77-.59c1.9-.51,3.84-1,5.77-1.62l11.77-3.49c3.94-1.19,7.92-2.35,11.93-3.44s8.09-2.06,12.26-2.83a72.16,72.16,0,0,1,12.67-1.26C242.33,351.07,242.89,353.68,243.4,356.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237.45,330.76a69,69,0,0,0-8.5-2.42,33.31,33.31,0,0,0-4.88-.64l-1.19,0c-.37,0-.73,0-1.1.05a18,18,0,0,0-2.24.36,36.82,36.82,0,0,0-9.12,3.93c-3,1.72-6,3.72-8.9,5.71a71.13,71.13,0,0,1-9.17,5.58,29.82,29.82,0,0,1-5.15,2,25.51,25.51,0,0,1-2.76.58L183,346a11.16,11.16,0,0,1-1.53,0,28.36,28.36,0,0,1-5.53-1c-1.76-.44-3.47-1-5.16-1.55-3.39-1.12-6.7-2.33-10-3.48s-6.61-2.27-9.89-3.29a66.41,66.41,0,0,0-9.76-2.4,18.27,18.27,0,0,0-4.67-.1,34.1,34.1,0,0,0-4.85.91,80.24,80.24,0,0,0-9.74,3.28q-4.29,1.74-8.54,3.72c.31-1.15.63-2.31,1-3.49q3-1.83,6.09-3.46a70,70,0,0,1,10-4.34,37.91,37.91,0,0,1,5.46-1.37,21.83,21.83,0,0,1,5.87-.22c7.6.76,14.29,3.44,20.87,6.07l9.76,4c1.61.67,3.23,1.3,4.83,1.91a33.59,33.59,0,0,0,4.73,1.47,8.63,8.63,0,0,0,1.12.16l1.22.05,1.23,0c.42,0,.83-.08,1.24-.12a22.47,22.47,0,0,0,4.91-1.22,38.49,38.49,0,0,0,9-5.1c1.41-1,2.75-2.17,4.12-3.28l4.08-3.45c2.77-2.26,5.75-4.56,9.55-5.78a15.11,15.11,0,0,1,2.94-.66c.51-.07,1-.08,1.54-.11l1.45,0a33,33,0,0,1,5.58.88,46.22,46.22,0,0,1,6.34,2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M151.71,232c-44.55,18.89-79.14,35.34-74.12,52.46,2,6.72,13.6,24.85,28.54,24.83,11.74,0,32.67-18.84,56.52-51.79C175,240.45,179.84,220.06,151.71,232Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.61,266.54c-1.9,1.57-3.79,3.18-5.64,4.82l1.19-1.38c3.19-3.78,6.34-7.59,9.49-11.4.06-.08-.07-.18-.14-.1-6,6.38-12,12.7-18.07,19.06s-21.9,22.47-25.75,25.63c-.08.07,0,.2.1.14,3.48-2.72,13.25-10.9,16.37-13.95q7.07-6.92,13.59-14.28a113.86,113.86,0,0,0,9.07-8.34C159.93,266.63,159.74,266.43,159.61,266.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.52,298.93c-19.48-8-32.1-67.09-36.88-106.86-.91-7.57,58.93-14.86,59-6.71C115.88,231.88,114.86,307.67,93.52,298.93Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.12,161.07c.35,12.69,11.22,44.46,16.23,49.65s43-13,45.09-20,3.89-48.62-4.48-58.5S48.75,147.93,49.12,161.07Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.79,150c-3.32,5.85-8.31-1.41-8.31-1.41s4.67,12.18-1.08,16.89c-5.56,4.52-11.29-4.46-11.7-5.1.24.65,4.24,12-2,16.09-6.52,4.29-10.72-5.71-11-6.36,0,.69.37,9.71-5.11,11.77-9.41,3.54-10.89-19.52-17.22-24.64,0,0-9.89,4.6-10.24,4.82,0,0-1.85-16.76,5.52-24.92a7,7,0,0,1,8.66-1.52s-1.37-7,3.46-10.41c2.48-1.75,7.49.68,7.49.68s-.87-5.65,3.61-8.42c3.58-2.22,8,.56,8,.56s1.68-5.81,6.07-6.9C100.81,108.9,122.88,137.44,115.79,150Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.66,118.33a.1.1,0,0,1,.13-.14c9.55,7.61,17.71,18.9,21,30.73.11.39-.48.74-.68.33C101.39,137.7,95.39,127.9,86.66,118.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.18,125.67c-.09-.1.08-.26.2-.17,9.8,7.9,18.64,20.87,20.82,35,.08.48-.34,1-.47.44C92.57,151.64,82.08,134.25,74.18,125.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5,171.12c-2.62-13.43-9.28-24.67-17.78-35.23-.11-.14.1-.28.22-.19,5.57,4,10.28,11.33,13.47,17.32A36.12,36.12,0,0,1,82,171C82,171.28,81.55,171.41,81.5,171.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48,148.56a40.87,40.87,0,0,1,1.36,7.39,13.7,13.7,0,0,1-1,7.13,4.5,4.5,0,0,1-2.37,2.22,6.59,6.59,0,0,1-3.31.39,8,8,0,0,1-5.26-3.9l-2.9-4.69,1.1,5.41a22.69,22.69,0,0,1,.33,7.3c-.31,2.37-1.25,4.65-3.06,5.85a4.62,4.62,0,0,1-5.8-.14,13.89,13.89,0,0,1-3.9-5.79l-2.39-6.08.26,6.5a20.84,20.84,0,0,1-.46,5.39,8.74,8.74,0,0,1-2.27,4.5,4.16,4.16,0,0,1-4.28.92,9.2,9.2,0,0,1-3.67-3.59A72.23,72.23,0,0,1,65,167.17c-.75-1.76-1.51-3.52-2.35-5.25a13.75,13.75,0,0,0-3.28-4.71,14.73,14.73,0,0,1,2.79,4.92c.7,1.77,1.32,3.58,1.94,5.39a61.13,61.13,0,0,0,4.49,10.68,10.84,10.84,0,0,0,4.27,4.45,5.89,5.89,0,0,0,6.36-1.12,10.67,10.67,0,0,0,3-5.51,23.21,23.21,0,0,0,.6-6l-2.12.42a16,16,0,0,0,4.55,6.89,6.68,6.68,0,0,0,4.24,1.57,7.61,7.61,0,0,0,4.24-1.42c2.53-1.76,3.57-4.75,3.87-7.4a24.34,24.34,0,0,0-.49-8l-1.81.73a9.61,9.61,0,0,0,6.76,4.48,8.08,8.08,0,0,0,4.07-.69,5.89,5.89,0,0,0,2.9-3c1.1-2.55.87-5.23.52-7.73A33.92,33.92,0,0,0,107.48,148.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.62,193.4s30.86-56.5,2-57.25c-7-.18-34.81,11.1-32.8,16.73,2.6,7.28,15,5.05,22.64,2.41,0,0-9.13,16.08.17,25.78A36.8,36.8,0,0,1,111.62,193.4Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.62,136.12a28.12,28.12,0,0,0-8.16.88,60.25,60.25,0,0,0-7.89,2.39,94.85,94.85,0,0,0-15,6.93A15.69,15.69,0,0,0,81.13,149a5.71,5.71,0,0,0-1.28,2.14,4,4,0,0,0-.21,1.37,4.37,4.37,0,0,0,.25,1.34A7,7,0,0,0,83,157.51a13.07,13.07,0,0,0,4.28,1.38,25.07,25.07,0,0,0,8.49-.43,56.91,56.91,0,0,0,8-2.27l-1.13-1.39a33.45,33.45,0,0,0-2.37,5.86,30.65,30.65,0,0,0-1.23,6.14,21.82,21.82,0,0,0,.38,6.25,16.37,16.37,0,0,0,2.39,5.69,18.26,18.26,0,0,1-1.73-5.81,22.26,22.26,0,0,1,.16-6,29.69,29.69,0,0,1,1.5-5.79,32.37,32.37,0,0,1,2.54-5.38l1.27-2.09-2.4.71a60.85,60.85,0,0,1-7.77,1.94,24.29,24.29,0,0,1-7.77.31c-2.43-.37-4.93-1.51-5.61-3.5-.76-1.7,1.55-3.61,3.7-5a74.64,74.64,0,0,1,7-3.92c2.41-1.24,4.84-2.44,7.32-3.51C105.08,138.67,110.17,136.55,115.62,136.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,196.85l-62.23,13.6s-4.1,11.8-.48,24.05c6.87,23.24,27.36,73.13,43.89,72,17.9-1.25,22.25-63.61,22-94.15C121,202,118,196.85,118,196.85Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.11,221.12c0,1.31,0,2.66-.09,4-1.5.75-3,1.46-4.62,2.07-1.17.46-2.37.88-3.59,1.24-.62.18-1.24.36-1.87.5a17.19,17.19,0,0,1-2,.35,22,22,0,0,1-7.77-.64c-2.45-.57-4.79-1.35-7.16-1.89a35.46,35.46,0,0,0-7.14-1,25,25,0,0,0-7,.79c-.56.14-1.13.32-1.66.49s-1,.39-1.56.61c-1.05.48-2.13,1-3.21,1.51l-6.51,3.18c-2.18,1.07-4.39,2.14-6.62,3.16-1.35.64-2.73,1.23-4.13,1.8-.31-1-.6-1.93-.87-2.84-.21-.69-.39-1.38-.53-2.07,3.41-1.34,6.86-2.74,10.32-4.15,2.27-.9,4.52-1.85,6.88-2.65,1.18-.39,2.36-.79,3.61-1.09.63-.15,1.26-.3,2-.4s1.28-.15,1.92-.18c5.14-.3,10,.64,14.86,1.21a50.76,50.76,0,0,0,14.05,0c1-.18,2.16-.45,3.28-.75s2.23-.65,3.35-1C117,222.69,119.07,221.93,121.11,221.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.77,232c0,.72-.06,1.44-.1,2.17-.82.69-1.65,1.36-2.51,2a42.82,42.82,0,0,1-5.38,3.5,23.22,23.22,0,0,1-3,1.33,13.36,13.36,0,0,1-3.4.7c-4.51.29-8.66-.62-12.76-1.51l-6.08-1.4c-1-.23-2-.44-3-.64a20.37,20.37,0,0,0-2.9-.4,4.8,4.8,0,0,0-.66,0l-.72.09-.72.14c-.23,0-.47.13-.71.19A13.22,13.22,0,0,0,76,239.43a22.09,22.09,0,0,0-4.76,3.85c-.73.74-1.4,1.53-2.09,2.31l-2,2.41a17.34,17.34,0,0,1-5,4.3,4.51,4.51,0,0,1-.63.29c-.31-.81-.61-1.61-.91-2.41.15-.06.31-.11.46-.18A21.82,21.82,0,0,0,66,246.82c1.6-1.3,3.11-2.75,4.63-4.19a41.66,41.66,0,0,1,4.81-4.15,17.36,17.36,0,0,1,2.8-1.66c.51-.23,1-.42,1.56-.6l.81-.23c.28-.06.61-.12.89-.15a17.45,17.45,0,0,1,3.32,0c1.07.09,2.12.24,3.16.4,2.08.33,4.13.71,6.17,1.06s4.07.68,6.08.95a39.11,39.11,0,0,0,5.92.45,10.93,10.93,0,0,0,2.74-.4,20,20,0,0,0,2.73-1,46.12,46.12,0,0,0,5.36-2.86Q118.9,233.31,120.77,232Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M117.23,213.6c-30.78,8.64-53,12.65-57.33,13.32a.09.09,0,0,1,0-.18c21.39-6.56,55.23-13.34,57.31-13.51A.19.19,0,0,1,117.23,213.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.26,250.6c-.73,5.83-2.39,15.08-3.73,20.8-.09.36-.18.72-.26,1.08a34.11,34.11,0,0,1,.57,6.22c0,2.44-.21,4.85-.46,7.27,0,.1-.17.09-.16,0a48.47,48.47,0,0,0-.06-7.23c-.11-1.43-.23-2.87-.35-4.31-1.31,5.46-2.69,10.92-4.39,16.27,0,.1-.18,0-.15-.06,1.28-5.81,2.65-11.61,3.72-17.46s3.52-19.58,4.54-25.39C120.34,243.18,120.49,248.77,120.26,250.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,226.31c.73,2.13,12.52,15.28,22.44,13.84,3.24-.48,1.43-18.23,1.43-18.23l.17-1.34,2.32-18.78-26.23-13.27S176.69,225.4,177,226.31Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.34,201.81,201,220.57l-.16,1.35s.32,3.22.45,6.94c-13.78-.69-21-10.29-24.4-17.07.06-10.65.21-23.26.21-23.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.59,169.8c9.58,39.38-12.93,49.56-21.43,51.62-7.71,1.86-34.2,7.23-47.79-30.95s1.69-55.08,19.1-60.28S223,130.41,232.59,169.8Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.28,170.93a26.11,26.11,0,0,1-2.8-.11,4.5,4.5,0,0,1-2.83-.65,1.44,1.44,0,0,1-.29-1.74,3.54,3.54,0,0,1,3.33-1.41,5.23,5.23,0,0,1,3.56,1.27A1.54,1.54,0,0,1,221.28,170.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,176.93a27.72,27.72,0,0,0,2.61-1,4.5,4.5,0,0,0,2.45-1.55,1.43,1.43,0,0,0-.3-1.74,3.56,3.56,0,0,0-3.61-.23,5.26,5.26,0,0,0-2.94,2.38A1.54,1.54,0,0,0,193.26,176.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.12,204.13c.73.57,1.48,1.38,2.48,1.36a7.3,7.3,0,0,0,2.88-1,.1.1,0,0,1,.13.13,3.71,3.71,0,0,1-3.32,1.86,2.92,2.92,0,0,1-2.42-2.19C204.81,204.13,205,204,205.12,204.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.06,197.58a11.36,11.36,0,0,1-3.39,4.62,5.06,5.06,0,0,1-2.92,1c-2.31.06-2.93-1.9-3-3.7a11.84,11.84,0,0,1,.23-2.86A14.64,14.64,0,0,0,215.06,197.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.68,200.13c-.11.15-.23.32-.36.47a9.44,9.44,0,0,1-2.19,0C212,200.44,212.85,200.29,213.68,200.13Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.81,200.41a7.24,7.24,0,0,1-1.67-.18,8,8,0,0,1-1.39-.5c0-.06,0-.14,0-.2s0-.2,0-.3A26,26,0,0,0,208.81,200.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.87,192.4s1.23,4,1.55,5.89c0,.18-.42.34-1.06.48,0,0-.05,0-.08,0a9.25,9.25,0,0,1-9.42-1.93.2.2,0,0,1,.24-.32,13.91,13.91,0,0,0,8.73,1c0-.55-2.36-6.8-2.05-6.8,1.31,0,3.65.19,4.52.26-.75-2.6-3.23-9.87-4.58-14.61-.08-.29.37-.47.48-.2a130.61,130.61,0,0,1,6.34,16.12C219.67,192.75,215.69,192.59,214.87,192.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45,184.3a3.93,3.93,0,0,1,.59-2,2.82,2.82,0,0,1,1.9-1.17,2.51,2.51,0,0,1,2.12.77,4.48,4.48,0,0,1,1,1.77,10.19,10.19,0,0,1,.24,1.2,5.6,5.6,0,0,1-.22,2.51,8.28,8.28,0,0,0-.34-1.81,11.81,11.81,0,0,0-.57-1.55c-.49-1-1.23-1.83-2.08-1.67s-1.46.92-1.68,2a18.29,18.29,0,0,0-.22,3.52A8.13,8.13,0,0,1,195.45,184.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.69,179a3.84,3.84,0,0,0-1.29-1.6,2.79,2.79,0,0,0-2.2-.37,2.48,2.48,0,0,0-1.67,1.51,4.28,4.28,0,0,0-.25,2,8,8,0,0,0,.23,1.2,5.32,5.32,0,0,0,1.15,2.24,7.69,7.69,0,0,1-.37-1.8,10.3,10.3,0,0,1,0-1.66c.06-1.13.44-2.15,1.29-2.32s1.7.29,2.32,1.25a18.36,18.36,0,0,1,1.53,3.18A7.85,7.85,0,0,0,222.69,179Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.47,194c12.05.13,17.47-14.55,14-25.89,0,0,32.16,2.34,32.17-23.36A25.18,25.18,0,0,0,227,155l4.13,9.23c3.22-1.14,6.15-10.64-2.29-17.47,0,0-1.3-12.73-11.17-19.84a17.47,17.47,0,0,0-18.92-1.52,26.44,26.44,0,0,0-19.52-3.6C167.61,124,163.4,135,163.4,135s-15.63,4-17.65,15.34A23.32,23.32,0,0,0,150,169s-3.7,4.65-1.12,14.11C150.5,189.14,155.86,194,159.47,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.78,142.54a29.85,29.85,0,0,1,.44,6.25,25.12,25.12,0,0,1-.8,6.12,16.19,16.19,0,0,1-6.84,9.63c-3.31,2.41-7.55,3-11.59,3.64-2.07.06-4.15.27-6.24.21s-4.18-.22-6.3-.26c2.07.37,4.16.66,6.26,1s4.23.13,6.37.2c4.2-.42,8.62-1,12.31-3.55a16.93,16.93,0,0,0,7.14-10.6A25.46,25.46,0,0,0,204.78,142.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,135a29.46,29.46,0,0,0-11.61,3.25,17.79,17.79,0,0,0-8.43,8.82,19.48,19.48,0,0,0-1.15,6.09,18.09,18.09,0,0,0,.66,6.12A16.53,16.53,0,0,0,150,169a18.13,18.13,0,0,1-6-9.91,20.25,20.25,0,0,1,.76-11.39,15.27,15.27,0,0,1,3-4.8,23.54,23.54,0,0,1,4.57-3.58A37.61,37.61,0,0,1,163.4,135Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79,125.44a30.14,30.14,0,0,1,9.27-2.36,18.26,18.26,0,0,1,9.12,1.46,18.53,18.53,0,0,1,7,6,33,33,0,0,1,4.32,8.55,23.84,23.84,0,0,0-3.38-9.18,16.47,16.47,0,0,0-17.22-8A22.77,22.77,0,0,0,198.79,125.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.11,156.37a33.36,33.36,0,0,1-10-4.64,20.37,20.37,0,0,1-4-3.68,24.53,24.53,0,0,1-3-4.69,13.56,13.56,0,0,0,2,5.36,14.83,14.83,0,0,0,4,4.21,18.49,18.49,0,0,0,5.19,2.57A17.08,17.08,0,0,0,222.11,156.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.76,199.28a14.16,14.16,0,1,1,12.45-18.57h0a14.19,14.19,0,0,1-9,17.89A14.54,14.54,0,0,1,196.76,199.28Zm-1.85-26.36a12.57,12.57,0,0,0-3,.59,12.26,12.26,0,1,0,3-.59Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.42,193.16c-5.41.38-10.69-4.81-12.07-12.07a17,17,0,0,1,1.1-10.28,8.82,8.82,0,0,1,14.84-2.8,16.92,16.92,0,0,1,4.77,9.16c1.45,7.67-2,14.79-7.72,15.87A7.24,7.24,0,0,1,227.42,193.16ZM224.14,167c-.24,0-.47,0-.71.09a7.57,7.57,0,0,0-5.27,4.54,15,15,0,0,0-.95,9.12c1.26,6.64,6.08,11.33,10.78,10.44s7.47-7,6.21-13.65a15,15,0,0,0-4.21-8.15A7.79,7.79,0,0,0,224.14,167Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.18,182.38l-1.24-1c1.5-1.83,5.23-4.61,8.68-2.09l-1,1.28C212.59,178.3,209.32,182.22,209.18,182.38Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.16,196.12l-1.53-.46c.22-.71,2.18-7,5.57-8.23,3.18-1.14,24.56-3.14,25.47-3.23l.15,1.59c-6.13.57-22.62,2.25-25.07,3.14C155.51,189.75,153.68,194.4,153.16,196.12Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.73,192.28s-10.66-11.16-15.85-7.18,4.15,21.11,11.19,22.57a6.85,6.85,0,0,0,8.52-5Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.68,189.94a.1.1,0,0,0,0,.19c5,1.17,8.08,5.13,10.49,9.36-1.65-1.52-3.69-2.18-5.75-.17-.11.11,0,.28.17.23a4.23,4.23,0,0,1,4.81.75,20.47,20.47,0,0,1,2.76,3.38c.28.38,1,0,.77-.41l-.06-.11C171.07,197.19,165.17,189.56,158.68,189.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.62,229c-1.64-2,8.91-8,11.65-5.74s16.61,37.44,12.11,75.61S106,378.17,103.25,372.46c-1.14-2.4.32-9.09,2.12-11.23,2.53-3,55.88-36.12,61.15-59.79C171.2,280.39,164.78,234.2,160.62,229Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.21,228.2c-2.22-4.21,9.21-.82,10.46,1.45s16.53,38.74,19.17,62.58c1,9.55,4.75,35.26,4.75,35.26S225.43,293,216.23,264.12A304.78,304.78,0,0,0,202.21,228.2Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.51,378.76s11.7-42.21,21-56.54,26.76-30.08,26.76-30.08S465.9,357.21,418.51,378.76Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.35,378A201,201,0,0,0,430,357.59a143.81,143.81,0,0,1,5.81-22.2c.05-.13.24-.06.21.08-1.55,6.66-3.36,13.27-5,19.92,4.72-10.27,9.21-20.67,14.83-30.38a64.92,64.92,0,0,1,5.43-13.51c.06-.12.26-.06.2.07a87.7,87.7,0,0,0-3.65,10.14,101.54,101.54,0,0,1,8.89-12.35c.21-.24.62,0,.41.29-7.52,9.65-12.71,20.62-17.65,31.73a169.11,169.11,0,0,0,14.68-18.44c0-.06.14,0,.1.07a151.08,151.08,0,0,1-15.72,20.49c-3.6,8.14-7.14,16.31-11.43,24.06,8.58-7.29,15.18-16.72,21.71-25.82a.19.19,0,0,1,.32.22c-6.54,10-13.3,19.39-22.7,26.78a102.66,102.66,0,0,1-6.28,9.86A.5.5,0,0,1,419.35,378Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.88,382.56s21-38.92,14.92-76.65-12.65-51.17-12.65-51.17S384.1,313.43,414.88,382.56Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.25,321.38a184.9,184.9,0,0,0,8.12,31.42c.06-13.85.32-27.69.69-41.54a107.59,107.59,0,0,1-4-25.79c0-.25.37-.24.39,0a148.05,148.05,0,0,0,3.69,22.19q.48-17.13,1.1-34.26a.15.15,0,0,1,.3,0c0,17.84,0,35.68-.12,53.53a142.35,142.35,0,0,0,6.06-21.2.07.07,0,0,1,.13,0c-.64,8.33-3.16,16.39-6.21,24.12-.08,11.41-.2,22.81-.46,34.22,3.56-12.13,7.36-23.87,8.39-36.69a.13.13,0,1,1,.26,0c-.27,14.13-3.9,28.47-8.53,41.76a.87.87,0,0,1-.24.34q-.15,6.24-.36,12.5a.46.46,0,0,1-.92,0q-.26-12.79-.21-25.58c-4.72-11-7.24-23.19-8.29-35C406.06,321.29,406.24,321.27,406.25,321.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.69,315.36a71.29,71.29,0,0,1,1.47,10.28c0,.12-.17.13-.2,0a73.61,73.61,0,0,1-1.73-10.25C407.2,315.15,407.64,315.1,407.69,315.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,286.91c0-.12.2-.08.2,0a26.17,26.17,0,0,1-1.06,7.09c-.05.19-.32.1-.28-.08C419.31,291.61,419.59,289.26,420,286.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.22,385.54s.85-40.63-10.74-60.82-30.82-30.48-30.82-30.48S373.41,365.85,407.22,385.54Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.09,350.8c4.87,7.05,9.72,13.85,15.69,20q-3.48-12.46-8-24.5c-6.5-5.73-12.94-11.67-16.93-19.51-.06-.12.12-.23.19-.11,4.29,6.94,10,12.5,16.05,17.84a316.09,316.09,0,0,0-16.13-35.33.26.26,0,0,1,.44-.26,194.61,194.61,0,0,1,10.12,18.55c-1.09-4.35-2-8.79-3.07-13.1a.09.09,0,0,1,.18-.05c2.06,5.43,4.1,11.43,4.76,17.23a207.91,207.91,0,0,1,10.21,27.8c-.3-6.09-.68-12.15-1.3-18.23,0-.11.18-.14.2,0a99.59,99.59,0,0,1,1.75,20.46c1.67,6.05,3.08,12.18,4.21,18.35,0,.17-.21.24-.25.07-.63-2.59-1.32-5.15-2-7.71,0,0-.09,0-.13,0-6.22-6.27-12.12-13.4-16-21.39C386,350.79,386.06,350.76,386.09,350.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.66,317.74c1.29,1.4,2.47,2.88,3.72,4.32a33.59,33.59,0,0,1,3.34,3.92c0,.06,0,.13-.09.09a19.4,19.4,0,0,1-3.86-3.82,32.72,32.72,0,0,1-3.3-4.37C372.4,317.77,372.57,317.64,372.66,317.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.66,380.58l-1.46,13L435.79,433h-38.4L393,393.6l-1.47-13h50.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.66,380.58l-1.46,13H393l-1.47-13h50.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.11,
    y: 371.14,
    width: 56.96,
    height: 14.75,
    transform: "translate(833.18 757.02) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.75,
    y: 419.41,
    width: 114.9,
    height: 13.6,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.29,
    y: 419.41,
    width: 4.68,
    height: 13.6,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.9,
    y: 419.41,
    width: 11.23,
    height: 13.6,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.02,
    y: 379.65,
    width: 117.36,
    height: 17.97,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.43,
    y: 385.48,
    width: 28.19,
    height: 6.31,
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.75,388.63a3.73,3.73,0,1,1-3.72-3.49A3.61,3.61,0,0,1,374.75,388.63Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.36,
    y: 363.75,
    width: 59.29,
    height: 15.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.65,
    y: 363.75,
    width: 54.8,
    height: 15.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.36,
    y: 365.4,
    width: 59.29,
    height: 12.57,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,368q9.32-.12,18.64-.18l8.43-.06,18.63.06c6.21,0,2.22.09,8.43.18-6.21.09-2.22.15-8.43.19l-18.63.05-8.43-.05Q272.84,368.11,263.52,368Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,370.45q9.32-.13,18.64-.18l8.43-.06,18.63.05c6.21,0,2.22.1,8.43.19-6.21.09-2.22.15-8.43.18l-18.63.06-8.43-.06Q272.84,370.59,263.52,370.45Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,372.91q9.32-.12,18.64-.18l8.43-.05,18.63.05c6.21,0,2.22.1,8.43.18-6.21.09-2.22.16-8.43.19l-18.63,0-8.43,0Q272.84,373.05,263.52,372.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,375.38q9.32-.13,18.64-.18l8.43-.06,18.63.06c6.21,0,2.22.09,8.43.18-6.21.09-2.22.15-8.43.18l-18.63.06-8.43-.06Q272.84,375.52,263.52,375.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.79,
    y: 363.75,
    width: 7.72,
    height: 15.86,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.43,
    y: 363.75,
    width: 5.19,
    height: 15.86,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.77,
    y: 397.61,
    width: 66.77,
    height: 21.8,
    transform: "translate(686.32 817.01) rotate(180)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.07,
    y: 397.61,
    width: 50.7,
    height: 21.8,
    transform: "translate(568.85 817.01) rotate(180)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.77,
    y: 399.87,
    width: 66.77,
    height: 17.27,
    transform: "translate(686.32 817.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.22,413.59q-7.8.14-15.61.18l-15.61.06-15.61-.06q-7.81,0-15.62-.18,7.82-.13,15.62-.18l15.61-.06,15.61.06Q364.42,413.46,372.22,413.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.22,410.2q-7.8.14-15.61.18l-15.61.06-15.61-.05q-7.81-.06-15.62-.19,7.82-.13,15.62-.18L341,410l15.61.06Q364.42,410.07,372.22,410.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.22,406.81q-7.8.13-15.61.19l-15.61.05L325.39,407q-7.81-.06-15.62-.19,7.82-.13,15.62-.18l15.61-.06,15.61.06Q364.42,406.68,372.22,406.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.22,403.42q-7.8.13-15.61.19l-15.61.05-15.61-.05q-7.81,0-15.62-.19,7.82-.14,15.62-.18l15.61-.06,15.61.06C361.82,403.27,367,403.34,372.22,403.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.15,
    y: 397.61,
    width: 9.49,
    height: 21.8,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.92,103.66a35.72,35.72,0,0,1-57,28.68l-17.5,4.47,7.29-16.3a35.73,35.73,0,1,1,67.23-16.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.92,103.66a36,36,0,0,1-5.3,18.75,41.91,41.91,0,0,1-2.84,4,39.63,39.63,0,0,1-3.42,3.56,24,24,0,0,1-1.86,1.62l-2,1.49c-.66.49-1.39.88-2.09,1.33l-1.05.65c-.36.2-.74.37-1.1.55-.75.36-1.48.74-2.23,1.08l-2.32.87a17.52,17.52,0,0,1-2.37.72c-.8.19-1.58.46-2.4.58a33.9,33.9,0,0,1-4.92.6,31.59,31.59,0,0,1-5,0,36.49,36.49,0,0,1-9.67-2.14,36.86,36.86,0,0,1-8.73-4.72l.3.06-17.48,4.54-.88.23.37-.83,7.25-16.32v.43A35.39,35.39,0,0,1,243,105a36.06,36.06,0,0,1,12.94-29,35.84,35.84,0,0,1,14.49-7.28,36,36,0,0,1,44.48,34.89Zm0,0A35.84,35.84,0,0,0,301.1,75.57a36.23,36.23,0,0,0-14.55-6.7,35.77,35.77,0,0,0-16,.43,35.25,35.25,0,0,0-14.14,7.32,36.71,36.71,0,0,0-9.49,12.76,35.37,35.37,0,0,0,1.17,30.9l.11.21-.09.22L240.8,137l-.51-.61L257.82,132l.16,0,.14.1a35.23,35.23,0,0,0,18,7,30.84,30.84,0,0,0,4.9.07,36.26,36.26,0,0,0,4.87-.53c.81-.11,1.59-.38,2.39-.56a16.29,16.29,0,0,0,2.36-.68l2.31-.83,2.22-1.05c.37-.18.75-.34,1.11-.54l1-.63c.69-.43,1.43-.81,2.09-1.29l2-1.47a23.29,23.29,0,0,0,1.86-1.61,40.76,40.76,0,0,0,3.42-3.53,40.39,40.39,0,0,0,2.85-4A36,36,0,0,0,314.92,103.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.4 124.92 257.39 108.71 262.77 103.39 272.12 112.86 291.56 82.4 297.93 86.46 273.4 124.92",
    style: {
      fill: "#FFBE0B"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrades);
export default __webpack_public_path__ + "static/media/Grades.d424334a245ad300b1461c6db83db98e.svg";
export { ForwardRef as ReactComponent };